module.exports = __webpack_public_path__ + "static/hoshino-abaf107ac94d50695deefc6c1b54a1ad.png";